module.exports = __webpack_public_path__ + "media/creativeMedia/panel-1.2Landscape-edf7d2f1.png";